import { utils } from '@hh/global.js'
const { isMobile } = utils

class HHIngredientCarousel extends HTMLElement {
  connectedCallback() {
    this.showMoreBtn = this.querySelector('.js-show-more')
    this.list = this.querySelector('ul')
    this.cards = [...this.querySelectorAll('.js-ingredient-carousel-item')]
    this.arrows = [...this.querySelectorAll('.js-arrow')]
    this.nextArrow = this.querySelector('.js-arrow[data-dir="next"]')
    this.prevArrow = this.querySelector('.js-arrow[data-dir="prev"]')

    isMobile() ? this.initMobile() : this.initDesktop()
  }

  initMobile() {
    this.showMoreBtn.addEventListener('click', this.showMore.bind(this))
  }

  showMore() {
    let cardsToReveal = this.getHiddenCards().slice(0, 4)
    cardsToReveal.forEach((c) => c.classList.remove('hidden'))
    setTimeout(() => {
      cardsToReveal[0].setAttribute('tabIndex', 0)
      cardsToReveal[0].focus()
    }, 0)
    if (this.checkIfMoreHiding() == 0) {
      this.hideShowMoreButton()
    }
  }

  getHiddenCards() {
    return this.cards.filter((c) => c.classList.contains('hidden'))
  }

  checkIfMoreHiding() {
    return [...this.querySelectorAll('.js-ingredient-carousel-item.hidden')]
      .length
  }

  hideShowMoreButton() {
    this.showMoreBtn.classList.add('hidden')
  }

  initDesktop() {
    this.getHiddenCards().forEach((c) => c.classList.remove('hidden'))
    this.list.addEventListener(
      'scroll',
      () => {
        this.toggleArrows(this.checkIfMoreHidingDesktop())
      },
      { passive: true }
    )

    this.toggleArrows(this.checkIfMoreHidingDesktop())
    this.arrows.forEach((arrow) =>
      arrow.addEventListener('click', () => {
        this.move(arrow.dataset.dir)
      })
    )

    this.list.scrollTo({
      left: 0,
    })
  }

  toggleArrows(arr) {
    const [showNextArrow, showPrevArrow] = arr

    this.showHideArrow(this.prevArrow, showPrevArrow)
    this.showHideArrow(this.nextArrow, showNextArrow)
  }

  showHideArrow(arrow, show) {
    arrow.disabled = !show
  }

  checkIfMoreHidingDesktop() {
    return [
      this.list.scrollLeft + this.list.offsetWidth < this.list.scrollWidth,
      this.list.scrollLeft > 0,
    ]
  }

  move(e) {
    const newScrollPos =
      e === 'next'
        ? this.list.scrollLeft + this.cards[0].clientWidth
        : this.list.scrollLeft - this.cards[0].clientWidth
    this.list.scrollTo({
      left: newScrollPos,
    })
  }
}

customElements.define('hh-ingredient-carousel', HHIngredientCarousel)
